import { useState } from "react";
import { feedbackService } from "../services/feedbackService";

export const useFeedback = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const submitFeedback = async (auth, data) => {
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            if (!auth || !auth.user || !auth.user.access_token) {
                throw new Error("No access token available");
            }

            await feedbackService.submitFeedback(auth.user.access_token, data);
            setSuccess(true);
        } catch (err) {
            console.error("Feedback submission error:", err);
            setError(err.message || "Failed to submit feedback");
        } finally {
            setLoading(false);
        }
    };

    const reset = () => {
        setError(null);
        setSuccess(false);
        setLoading(false);
    };

    return { submitFeedback, loading, error, success, reset };
};
